import React, { useState, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import {
  AssessmentSpecStatus,
  RequestStatus,
  inviteBlock,
} from "../../../utils/Constants";
import {
  listAssessSpec,
  cloneAssessSpec,
  deleteAssessSpec,
  createAssessSpec,
  archiveAssessSpec,
  resetCurrAssessSpec,
  getAssessSpecStatsData,
  listAssessSpecWithQueryParam,
} from "../../../redux/thunks/AssessSpec";
import { useMediaQuery } from "@mui/material";
import {
  Route,
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom";
import AvtarBadge, {
  GetAvtarImage,
} from "../../../components/dashboard/AvtarBadge";
import Table from "../../../components/common/Table";
import { useDispatch, useSelector } from "react-redux";
import Assessments from "./assesment-listing/Assessments";
import AlertBox from "../../../components/common/AlertBox";
import CustomModal from "../../../components/common/Modal";
import Input from "../../../components/sub-component/Input";
import { getResource } from "../../../redux/thunks/Resource";
import Button from "../../../components/sub-component/Button";
import ProgressBar from "../../../components/common/ProgressBar";
import { AssessmentsRoutes, PathName } from "../../../utils/routes";
import CustomTooltip from "../../../components/common/CustomTooltip";
import { calculateTimeDifferenceInDays } from "../../../utils/utilities";
import DeskImage from "../../../assets/images/dashboard/Illustration.svg";
import { ReactComponent as BackArrow } from "../../../assets/icons/Arrows/CaretLeft.svg";
import AssessmentIcon from "../../../assets/icons/Views/dashboard/assessments/Avatar.png";
import { ReactComponent as ForwardArrow } from "../../../assets/icons/Arrows/CaretRight.svg";
import { ReactComponent as ActiveStatsIcon } from "../../../assets/icons/components/active.svg";
import { ReactComponent as PlusBtnIcon } from "../../../assets/icons/components/dashboard/plusBtn.svg";
import { ReactComponent as LinkIcon } from "../../../assets/icons/Views/dashboard/test-detail/link.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/Views/dashboard/test-detail/copy.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/Views/dashboard/test-detail/Edit.svg";
import { ReactComponent as Search } from "../../../assets/icons/Views/candidate/assessments/search.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Views/dashboard/assessments/plus.svg";
import { ReactComponent as SearchCrossIcon } from "../../../assets/icons/Views/dashboard/assessments/x.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/Views/dashboard/test-detail/btrash.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/icons/Views/dashboard/test-detail/archive.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/Views/dashboard/assessments/primary-x.svg";
import { ReactComponent as OpenAIIcon } from "../../../assets/icons/Views/dashboard/assessments/chat gpt.svg";
import { ReactComponent as DraftStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/draft-stats.svg";
import { ReactComponent as InvitedStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/invite-stats.svg";
import { ReactComponent as ArchiveStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/archive-stats.svg";
import { ReactComponent as AttemptsStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/attempt-stats.svg";
import { ReactComponent as AssessmentsStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/assessments-stats.svg";

export default function AdminAssessments(props) {
  /**
   * @type {TAssessSpecState}
   */

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { routeDetails } = props;
  const isOnTabScreen = useMediaQuery("(max-width: 1200px)");
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const assessSpec = useSelector((state) => state.assessSpecReducer);
  const auth = useSelector((state) => state.authReducer);
  const subscription = useSelector((state) => state.subscriptionReducer);
  const expireAt =
    subscription?.user_subscription.length > 0
      ? subscription?.user_subscription[0]?.expires_at
      : null;
  const daysLeft = calculateTimeDifferenceInDays(expireAt);
  const openLeftDaysDisclaimer = sessionStorage.getItem(
    "openLeftDaysDisclaimer",
  );
  const draftPopupShown = sessionStorage.getItem("draftPopupShown");
  const searchParams = new URLSearchParams(location.search);
  const pageNo = searchParams.get("page");
  const initialSearchQuery = searchParams.get("search") || "";

  const [alert, setAlert] = useState(null);
  const [testData, setTestData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [debouncedSearchQuery, setDebouncedSearchQuery] =
    useState(initialSearchQuery);
  const [customSearch, setCustomSearch] = useState();
  const searchUpdateTimeout = useRef(null);
  const [showTooltip, setShowTooltip] = useState(true);
  const selectedSortColumn = searchParams.get("sortColumn");
  const selectedSortOrder = (searchParams.get("sortOrder") || "").toUpperCase();

  const [selectedsortOption, setSelectedsortOption] = useState({
    column: selectedSortColumn || "created_at",
    order:
      selectedSortColumn && ["ASC", "DESC"].includes(selectedSortOrder)
        ? selectedSortOrder
        : "DESC",
    clickCount: 0,
  });

  const handleAssessmentSortOptionChange = (nextSortOption) => {
    setSelectedsortOption((prev) => {
      const nextColumn = nextSortOption?.column;
      const nextOrder = nextSortOption?.order;
      const nextClickCount = nextSortOption?.clickCount ?? prev.clickCount;

      if (nextOrder === "none") {
        return {
          column: null,
          order: "none",
          clickCount: nextClickCount,
        };
      }

      const normalizedColumn =
        nextColumn === "updated_at" || nextColumn === "created_at"
          ? nextColumn
          : prev.column || "created_at";
      const normalizedOrder = ["ASC", "DESC"].includes(nextOrder)
        ? nextOrder
        : "DESC";

      if (
        prev.column === normalizedColumn &&
        prev.order === normalizedOrder &&
        prev.clickCount === nextClickCount
      ) {
        return prev;
      }

      return {
        column: normalizedColumn,
        order: normalizedOrder,
        clickCount: nextClickCount,
      };
    });
  };

  useEffect(() => {
    // Keep local sort state as-is when URL has no explicit sort params.
    if (!selectedSortColumn || !selectedSortOrder) {
      return;
    }

    const normalizedSortOrder = ["ASC", "DESC"].includes(selectedSortOrder)
      ? selectedSortOrder
      : "DESC";

    setSelectedsortOption((prev) => {
      if (
        prev.column === selectedSortColumn &&
        prev.order === normalizedSortOrder
      ) {
        return prev;
      }

      return {
        ...prev,
        column: selectedSortColumn,
        order: normalizedSortOrder,
      };
    });
  }, [selectedSortColumn, selectedSortOrder]);
  const [actionAssessmentModal, setActionAssessmentModal] = useState({
    isOpen: false,
    assessSpec: null,
    action: "",
  });
  const [assessmentListRefreshKey, setAssessmentListRefreshKey] = useState(0);
  const getInitialRowsPerPage = () => {
    const saved = localStorage.getItem("assessmentsRowsPerPage");
    return saved ? parseInt(saved, 10) : 10;
  };
  const [highlightActiveRow, setHighlightActiveRow] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(getInitialRowsPerPage());
  const [currentPage, setCurrentPage] = useState(parseInt(`${pageNo}`) || 1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const variant =
    routeDetails.pathname === "/active"
      ? "active"
      : routeDetails.pathname === "/draft"
        ? "draft"
        : "archived";

  const data = assessSpec?.data?.results
    ? assessSpec?.data?.results?.filter((spec, _) => {
        return spec?.status === routeDetails?.text?.toUpperCase();
      })
    : [];

  const totalAssessments = assessSpec?.statsData?.stats
    ? assessSpec?.statsData?.stats?.total_spec_count
    : 0;

  const activeAssessments = assessSpec?.statsData?.stats
    ? assessSpec?.statsData?.stats?.active_spec_count
    : 0;

  const draftAssessments = assessSpec?.statsData?.stats
    ? assessSpec?.statsData?.stats?.draft_spec_count
    : 0;

  const archiveAssessments = assessSpec?.statsData?.stats
    ? assessSpec?.statsData?.stats?.archived_spec_count
    : 0;

  const totalInvited = assessSpec?.statsData?.stats
    ? assessSpec?.statsData?.stats?.spec_status_stats?.assess_invited
    : 0;

  const totalAttempted = assessSpec?.statsData?.stats
    ? assessSpec?.statsData?.stats?.spec_status_stats?.assess_completed
    : 0;

  const handleCloseDraftPopupShown = () => {
    sessionStorage.setItem("draftPopupShown", true);
    setShowTooltip(false);
  };

  const closeActionAssessmentModal = () => {
    setActionAssessmentModal({
      isOpen: false,
      assessSpec: null,
      action: "",
    });
  };

  const nextSlide = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevSlide = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const assessmentTableHeader = [
    {
      id: "assessmentTitle",
      name: "Test Title",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab", "mob"],
    },
    {
      id: "invitedCandidates",
      name: "Invited Candidates",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab"],
    },
    {
      id: "createdBy",
      name: "Created By",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab"],
    },
    {
      id: "created_at",
      name: "Created at",
      type: "string",
      disableSorting: true,
      backendSorting: true,
      screens: ["web"],
      timeDifference: true,
    },
    {
      id: "updated_at",
      name: "Last Activity",
      type: "string",
      disableSorting: true,
      backendSorting: true,
      screens: ["web"],
      timeDifference: true,
    },
    {
      id: "progress",
      name: "Completion Rate",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab"],
    },
    {
      id: "action",
      name: "Actions",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab", "mob"],
    },
  ];

  const assessmentTableHeaderViewOnly = [
    {
      id: "assessmentTitle",
      name: "Test Title",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab", "mob"],
    },
    {
      id: "invitedCandidates",
      name: "Invited Candidates",
      type: "component",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab"],
    },
    {
      id: "created_at",
      name: "Created at",
      type: "string",
      disableSorting: false,
      screens: ["web"],
      timeDifference: true,
    },
    {
      id: "updated_at",
      name: "Last Activity",
      type: "string",
      disableSorting: false,
      screens: ["web"],
      timeDifference: true,
    },
    {
      id: "progress",
      name: "Completion Rate",
      type: "component",
      disableSorting: false,
      screens: ["web", "tab", "mini_tab"],
    },
  ];
  const customSorting = {
    created_at: (a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA - dateB;
    },
    updated_at: (a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA - dateB;
    },
  };

  const searchColumns = ["title", "createdAt", "updatedAt"];

  const cloneAssessment = async (id, name) => {
    const res = await dispatch(cloneAssessSpec({ id: id }));
    if (res?.meta?.requestStatus === RequestStatus.REJECTED) {
      setAlert(
        <AlertBox
          style={{ zIndex: "99999" }}
          color="danger"
          description={res?.payload}
          title="Error"
          isOpen={true}
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
    } else {
      setAlert(
        <AlertBox
          style={{ zIndex: "99999" }}
          color="success"
          description={`${name} cloned successfully!`}
          title="Success"
          isOpen={true}
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
      history.push(`${PathName.ASSESSMENTS}/create/${res?.payload?.data?.id}`);
    }
  };

  const editAssessment = async (id) => {
    history.push(`${PathName.ASSESSMENTS}/create/${id}`);
  };

  useMemo(() => {
    if (assessSpec?.data?.results.length === 0) return [];
    const _data = data?.map((item, index) => {
      return {
        assessmentTitle: (
          <div className="d-flex align-items-center" style={{ gap: "6px" }}>
            <GetAvtarImage
              fontSize="0.75em"
              size="custom"
              height="26px"
              width="26px"
              turnOnBGColors
              src={{ image_id: item.avatar_id, name: item.title }}
            />
            <span
              style={{
                fontSize: "14px",
                fontWeight: "400",
                wordBreak: "break-all",
                height: "auto",
              }}
            >
              {item.title}
            </span>
          </div>
        ),
        invitedCandidates:
          item.candidates.length > 0 ? (
            <AvtarBadge
              key={1}
              showTooltip={true}
              varrient="multiple-badges"
              turnOnBGColors
              userCount={item.invited}
              users={item?.candidates?.map((_item, _) => {
                return {
                  ..._item,
                  image_id: null,
                  name: `${_item.first_name}${_item.last_name}`,
                  nameInitals: `${
                    _item.first_name?.charAt(0) + _item.last_name?.charAt(0)
                  }`,
                };
              })}
            />
          ) : (
            "0"
          ),
        createdAt: item?.created_at,
        updatedAt: item?.updated_at,
        progress: (
          <CustomTooltip
            position="top-end"
            width={"200px"}
            text={`${item.completed} out of ${item.invited} candidates have completed the assessment.`}
          >
            <ProgressBar
              value={parseFloat(
                ((item.completed / (item.invited || 1)) * 100).toFixed(1),
              )}
              key="1"
            />
          </CustomTooltip>
        ),
        action: (
          <div
            className="d-flex justify-content-between  align-items-center"
            key={`icon_${index}`}
            style={{ width: "fit-content", gap: "6px" }}
          >
            {item.status === "ACTIVE" && (
              <>
                {auth.data.role.name !== "Member" && (
                  <>
                    {inviteBlock.includes(auth?.data?.tenant_status) ? (
                      <CustomTooltip
                        customPosition={{ bottom: "12px", left: "8px" }}
                        text={
                          "You cannot share an assessment unless you fix your billing issues. Choose a plan from billing settings or pay your pending invoices."
                        }
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ height: "34px", opacity: "0.3" }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <span
                            className="link-icon icon-black-500"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </div>
                      </CustomTooltip>
                    ) : (
                      <CustomTooltip
                        position="top-end"
                        text={"Copy Invite Link"}
                      >
                        <div
                          className="icon-wrapper active-bg-success"
                          style={{ height: "34px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                              `${window.location.origin}/?invite_id=${item?.invite_id}`,
                            );
                            setAlert(
                              <AlertBox
                                style={{ zIndex: "99999" }}
                                color="success"
                                description={`${item?.title} assessment invite link copied successfully!`}
                                title="Success"
                                isOpen={true}
                                onCloseAlert={() => {
                                  setAlert(null);
                                }}
                              />,
                            );
                          }}
                        >
                          <LinkIcon
                            stroke={"#808191"}
                            width="20px"
                            height="20px"
                          />
                        </div>
                      </CustomTooltip>
                    )}
                  </>
                )}
                <CustomTooltip position="top-end" text="Archive Assessment">
                  <div
                    className="icon-wrapper"
                    style={{ height: "34px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setActionAssessmentModal({
                        isOpen: true,
                        assessSpec: item,
                        action: "archive",
                      });
                    }}
                  >
                    <ArchiveIcon
                      stroke={"#808191"}
                      width="20px"
                      height="20px"
                    />
                  </div>
                </CustomTooltip>
              </>
            )}
            {item.status === "DRAFT" && auth.data.role.name !== "Member" && (
              <CustomTooltip position="top-end" text="Delete Assessment">
                <div
                  className="icon-wrapper"
                  style={{ height: "34px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActionAssessmentModal({
                      isOpen: true,
                      assessSpec: item,
                      action: "delete",
                    });
                  }}
                >
                  <DeleteIcon stroke={"#808191"} width="20px" height="20px" />
                </div>
              </CustomTooltip>
            )}
            {auth.data.role.name !== "Member" && (
              <CustomTooltip position="top-end" text="Clone Assessment">
                <div
                  className="icon-wrapper"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActionAssessmentModal({
                      isOpen: true,
                      assessSpec: item,
                      action: "clone",
                    });
                  }}
                >
                  <CopyIcon stroke={"#808191"} width="20px" height="20px" />
                </div>
              </CustomTooltip>
            )}
            {item.status === "ACTIVE" && auth.data.role.name !== "Member" && (
              <CustomTooltip position="top-end" text="Edit Assessment">
                <div
                  className="icon-wrapper"
                  onClick={(e) => {
                    e.stopPropagation();
                    editAssessment(item?.id);
                  }}
                >
                  <EditIcon stroke={"#808191"} width="20px" height="20px" />
                </div>
              </CustomTooltip>
            )}
          </div>
        ),
        ...item,
      };
    });
    setTestData(_data ? [..._data] : []);
  }, [assessSpec?.data?.results, variant]);

  const handleCreateAssessSpec = async () => {
    const { payload } = await dispatch(createAssessSpec({ title: "New Test" }));
    history.push(`${PathName.ASSESSMENTS}/create/${payload.id}`);
  };

  useEffect(() => {
    dispatch(
      getAssessSpecStatsData({
        status:
          routeDetails.pathname === "/active"
            ? "ACTIVE"
            : routeDetails.pathname === "/draft"
              ? "DRAFT"
              : "ARCHIVED",
      }),
    );
  }, [dispatch, routeDetails.pathname, assessmentListRefreshKey]);

  useEffect(() => {
    if (assessSpec?.data === null) return;
    setTotalItems(assessSpec?.data?.count);
  }, [assessSpec?.data]);

  const handleRowsPerPageChange = (newLimit) => {
    setItemsPerPage(newLimit);
    setCurrentPage(1);
    localStorage.setItem("assessmentsRowsPerPage", newLimit);
  };

  useEffect(() => {
    if (assessSpec?.data?.results?.length === 0) {
      setQueryParam("page", 1);
      setCurrentPage(1);
    } else {
      setQueryParam("page", currentPage);
    }
  }, [
    assessSpec?.data?.results?.length,
    currentPage,
    history,
    location.search,
  ]);

  const setQueryParam = (key, value) => {
    const params = new URLSearchParams(location.search);
    if (value || value === 0) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  useEffect(() => {
    if (!pageNo) {
      setQueryParam("page", 1);
    }
  }, [routeDetails.pathname]);

  useEffect(() => {
    dispatch(
      listAssessSpecWithQueryParam({
        data: {
          page: currentPage,
          limit: itemsPerPage,
          sort_by:
            selectedsortOption.order === "none"
              ? ""
              : selectedsortOption.column || "created_at",
          sort_direction:
            selectedsortOption.order === "none" ? "" : selectedsortOption.order,
          status:
            routeDetails.pathname === "/active"
              ? "ACTIVE"
              : routeDetails.pathname === "/draft"
                ? "DRAFT"
                : "ARCHIVED",
          search: debouncedSearchQuery,
        },
      }),
    );
  }, [
    debouncedSearchQuery,
    dispatch,
    routeDetails.pathname,
    selectedsortOption,
    currentPage,
    itemsPerPage,
    assessmentListRefreshKey,
  ]);

  useEffect(() => {
    const delay = searchQuery === "" ? 1000 : 0;
    if (!assessSpec?.loading || testData?.length !== data?.length) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, delay);

      return () => clearTimeout(timer);
    } else {
      setLoading(true);
    }
  }, [assessSpec?.loading, testData, data, searchQuery]);

  useEffect(() => {
    if (searchUpdateTimeout.current) {
      clearTimeout(searchUpdateTimeout.current);
    }

    if (searchQuery === "") {
      setDebouncedSearchQuery("");
      setQueryParam("search", "");
      return;
    }

    searchUpdateTimeout.current = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
      setQueryParam("search", searchQuery);
    }, 500);

    return () => {
      if (searchUpdateTimeout.current) {
        clearTimeout(searchUpdateTimeout.current);
      }
    };
  }, [searchQuery]);

  const handleRowSelect = (row) => {
    if (
      row.status === AssessmentSpecStatus.ACTIVE ||
      row.status === AssessmentSpecStatus.ARCHIVED
    ) {
      history.push(`${PathName.ASSESSMENTS}/${row.id}`);
    } else {
      history.push(`${PathName.ASSESSMENTS}/create/${row.id}`);
    }
  };

  useEffect(() => {
    dispatch(resetCurrAssessSpec());
  }, [dispatch]);

  const defaultAssessmentCard = () => {
    return (
      <>
        <div className="default-assessment-card-container">
          <div
            className="default-assessment-text"
            style={{ marginTop: "24px" }}
          >
            <span className="body-1 dark-100">{`You don't have any ${
              variant === "archived"
                ? "archived"
                : variant === "draft"
                  ? "draft"
                  : "active"
            } assessments. Please click the Create New Assessment button above to create a new assessment.`}</span>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {alert}

      {
        <>
          <CustomModal
            open={actionAssessmentModal.isOpen}
            varrient="alert-warning-modal"
            processing={assessSpec?.processing}
            title={`${
              actionAssessmentModal.action === "archive"
                ? "Archive"
                : actionAssessmentModal.action === "delete"
                  ? "Delete"
                  : "Clone"
            } Assessment ?`}
            description={`Are you sure you want to ${
              actionAssessmentModal.action === "archive"
                ? "archive"
                : actionAssessmentModal.action === "delete"
                  ? "delete"
                  : "clone"
            } this assessment?`}
            dangerAlert={actionAssessmentModal.action === "delete" && true}
            warningAlert={actionAssessmentModal.action !== "delete" && true}
            handleCloseModal={closeActionAssessmentModal}
            confirmBtnTitle={
              actionAssessmentModal.action === "archive"
                ? "Archive"
                : actionAssessmentModal.action === "delete"
                  ? "Delete"
                  : "Clone"
            }
            onConfirm={async () => {
              if (actionAssessmentModal.action === "archive") {
                const res = await dispatch(
                  archiveAssessSpec({
                    data: data.filter((assessSpec, _) => {
                      return (
                        assessSpec.id !== actionAssessmentModal?.assessSpec?.id
                      );
                    }),
                    id: actionAssessmentModal?.assessSpec?.id,
                  }),
                );
                if (res?.meta?.requestStatus === RequestStatus.FULFILLED) {
                  setAssessmentListRefreshKey((prev) => prev + 1);
                }
              } else if (actionAssessmentModal.action === "clone") {
                cloneAssessment(
                  actionAssessmentModal?.assessSpec?.id,
                  actionAssessmentModal?.assessSpec?.title,
                );
              } else if (actionAssessmentModal.action === "delete") {
                const res = await dispatch(
                  deleteAssessSpec({
                    data: data.filter((assessSpec, _) => {
                      return (
                        assessSpec.id !== actionAssessmentModal?.assessSpec?.id
                      );
                    }),
                    id: actionAssessmentModal?.assessSpec?.id,
                  }),
                );
                if (res?.meta?.requestStatus === RequestStatus.FULFILLED) {
                  setAssessmentListRefreshKey((prev) => prev + 1);
                }
              }
              closeActionAssessmentModal();
            }}
          />
        </>
      }
      <div
        className="assessment-view-container hide-scrollbar"
        style={{ overflowY: "auto" }}
      >
        {assessSpec?.loading && assessSpec?.data?.results === null ? (
          <div
            style={{
              position: "fixed",
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
              height: "25px",
              width: "25px",
              margin: "auto",
            }}
          >
            <div
              className="processing-indicator primary"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        ) : (
          <div className="w-100 dashboard-page-mobile">
            {!isOnMobileScreen ? (
              <div
                className="dashboard-page hide-scrollbar"
                style={{ overflow: "hidden" }}
              >
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{
                    padding: "0px 0px 24px",
                    width: "99%",
                    margin: "auto",
                  }}
                >
                  <span className="headline-3 dark-100">{`${routeDetails?.text} Assessments`}</span>
                  <div
                    className="d-flex"
                    style={{ height: "52px", marginTop: "16px", gap: "16px" }}
                  >
                    <Button
                      preIcon={<PlusIcon color="white" />}
                      style={{
                        height: "44px",
                        background: "#121216",
                        padding: "12px 24px 12px 24px",
                        // width:'260px',
                        borderRadius: "50px",
                        border: "0px",
                      }}
                      size="md"
                      varrient="primary"
                      title={
                        isOnTabScreen ? "Create New " : " Create New Assessment"
                      }
                      btn="ragular-btn"
                      processing={assessSpec?.processing}
                      onClick={handleCreateAssessSpec}
                    />
                  </div>
                </div>
                <div
                  className={`${
                    daysLeft < 6 &&
                    auth?.data?.tenant_status === "trialing" &&
                    !openLeftDaysDisclaimer &&
                    "left-day-message-main-box"
                  } page-content hide-scrollbar`}
                  style={{ overflowY: "auto" }}
                >
                  <>
                    <div className="assessments-stats-container mt-3 mb-3">
                      <div className="assessments-stats">
                        <div className="assessments-stats-card d-flex justify-content-between">
                          <div className="stats-card-text">
                            <span className="body-2 dark-50">
                              {isOnTabScreen ? "Total" : "Total Assessments"}
                            </span>
                            <span className="headline-5 dark-100">
                              {totalAssessments}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <AssessmentsStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div className="assessments-stats-card d-flex justify-content-between">
                          <div className="stats-card-text">
                            <span className="body-2 dark-50">
                              {isOnTabScreen ? "Invites" : "Total Invites Sent"}
                            </span>
                            <span className="headline-5 dark-100">
                              {totalInvited}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <InvitedStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div className="assessments-stats-card d-flex justify-content-between">
                          <div className="stats-card-text">
                            <span className="body-2 dark-50">
                              {isOnTabScreen
                                ? "Evaluations"
                                : "Total Evaluations"}
                            </span>
                            <span className="headline-5 dark-100">
                              {totalAttempted}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <AttemptsStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        {routeDetails?.text?.toUpperCase() === "ARCHIVED" ? (
                          <div className="assessments-stats-card d-flex justify-content-between">
                            <div className="stats-card-text">
                              <span className="body-2 dark-50">
                                {isOnTabScreen
                                  ? "Archived"
                                  : "Archived Assessments"}
                              </span>
                              <span className="headline-5 dark-100">
                                {archiveAssessments}
                              </span>
                            </div>
                            <div className="AssessmentsStatsIcon-container">
                              <ArchiveStatsIcon className="AssessmentsStatsIcon" />
                            </div>
                          </div>
                        ) : routeDetails?.text?.toUpperCase() === "DRAFT" ? (
                          <div className="assessments-stats-card d-flex justify-content-between">
                            <div className="stats-card-text">
                              <span className="body-2 dark-50">
                                {isOnTabScreen ? "Draft" : "Draft Assessments"}
                              </span>
                              <span className="headline-5 dark-100">
                                {draftAssessments}
                              </span>
                            </div>
                            <div className="AssessmentsStatsIcon-container">
                              <DraftStatsIcon className="AssessmentsStatsIcon" />
                            </div>
                          </div>
                        ) : (
                          <div className="assessments-stats-card d-flex justify-content-between">
                            <div className="stats-card-text">
                              <span className="body-2 dark-50">
                                {isOnTabScreen
                                  ? "Active"
                                  : "Active Assessments"}
                              </span>
                              <span className="headline-5 dark-100">
                                {activeAssessments}
                              </span>
                            </div>
                            <div className="AssessmentsStatsIcon-container">
                              <ActiveStatsIcon className="AssessmentsStatsIcon" />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="w-100 hide-scrollbar"
                      style={{
                        height: "calc(100vh - 260px)",
                        borderRadius: "24px",
                        background: "white",
                        overflowY: "auto",
                        position: "relative",
                      }}
                    >
                      <div className="table-search-container">
                        <div className="table-search-input">
                          <Search height={"24px"} width={"24px"} />
                          <Input
                            inputStyle={{
                              background: "transparent",
                              border: "none",
                            }}
                            className={"w-100"}
                            placeholder={"Search"}
                            value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setCurrentPage(1);
                            }}
                          />
                          {searchQuery !== "" && (
                            <SearchCrossIcon
                              height={"24px"}
                              width={"24px"}
                              cursor={"pointer"}
                              onClick={() => {
                                setSearchQuery("");
                                setCurrentPage(1);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      {!draftPopupShown &&
                        draftAssessments > 0 &&
                        activeAssessments === 0 &&
                        archiveAssessments === 0 && (
                          <div className="label-custom-tooltip">
                            <div className="w-100 d-flex flex-row align-items-start justify-content-between">
                              <span className="body-2 white">
                                Saved as Draft
                              </span>
                              <CrossIcon
                                stroke={"#FFFFFF"}
                                width="20px"
                                height="20px"
                                cursor="pointer"
                                onClick={handleCloseDraftPopupShown}
                              />
                            </div>
                            <span className="body-2 white text-start">
                              All new assessments are saved as draft by default.
                            </span>
                          </div>
                        )}
                      {(assessSpec?.loading &&
                        assessSpec?.data?.results === null) ||
                      loading ? (
                        <div className="processing-indicator-wrapper medium-indicator w-100 h-100 d-flex align-items-center justify-content-center">
                          <div
                            className="processing-indicator primary"
                            style={{ width: "40px", height: "40px" }}
                          />
                        </div>
                      ) : assessSpec?.data?.results.length === 0 ? (
                        defaultAssessmentCard()
                      ) : (
                        <Table
                          headers={
                            auth.data.role.name === "Member"
                              ? assessmentTableHeaderViewOnly
                              : assessmentTableHeader
                          }
                          data={testData}
                          onSelectRow={handleRowSelect}
                          disableSearchInput={true}
                          setHighlightActiveRow={setHighlightActiveRow}
                          // searchColumns={searchColumns}
                          // customSorting={customSorting}
                          // customSearch={customSearch}
                          backendFilter={true}
                          setSelectedsortOption={
                            handleAssessmentSortOptionChange
                          }
                          selectedsortOption={selectedsortOption}
                          setCurrentPage={setCurrentPage}
                          currentPage={currentPage}
                          totalItems={totalItems}
                          itemsPerPage={itemsPerPage}
                          totalPages={totalPages}
                          nextSlide={nextSlide}
                          prevSlide={prevSlide}
                          nullTableLoading={true}
                          // nullTableTitle={"No Assessments to show"}
                          // nullTableDescription={`Try adjusting your search query or filters`}
                          onRowsPerPageChange={handleRowsPerPageChange}
                        />
                      )}
                    </div>
                  </>
                </div>
              </div>
            ) : (
              <div className="dashboard-page" style={{ width: "100%" }}>
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ width: "99%", margin: "auto" }}
                >
                  <span className="subtitle-1 dark-100">{`${routeDetails?.text} Assessments`}</span>
                  <div
                    className="d-flex"
                    style={{ height: "52px", marginTop: "16px", gap: "16px" }}
                  >
                    <div
                      onClick={handleCreateAssessSpec}
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        height: "44px",
                        width: "44px",
                        background: "#121216",
                        borderRadius: "50px",
                      }}
                    >
                      <PlusIcon color="white" stroke="white" />
                    </div>
                  </div>
                </div>
                <div
                  className={`${
                    daysLeft < 6 &&
                    auth?.data?.tenant_status === "trialing" &&
                    !openLeftDaysDisclaimer &&
                    "left-day-message-main-box"
                  } page-content`}
                >
                  <>
                    <div
                      className="assessments-stats-container mt-3"
                      style={{ overflow: "hidden" }}
                    >
                      <div className="assessments-stats">
                        <div className="assessments-stats-card">
                          <div className="stats-card-text">
                            <span className="body-2 dark-50 ">
                              {isOnTabScreen ? "Total" : "Total Assessments"}
                            </span>
                            <span className=" headline-5 dark-100">
                              {totalAssessments}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <AssessmentsStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div className="assessments-stats-card">
                          <div className="stats-card-text">
                            <span className="body-2 dark-50">
                              {isOnTabScreen
                                ? "Invites"
                                : "Total Invites Sent"}{" "}
                            </span>
                            <span className="headline-5 dark-100">
                              {totalInvited}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <InvitedStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div className="assessments-stats-card ">
                          <div className="stats-card-text">
                            <span className="body-2 dark-50 ">
                              {isOnTabScreen
                                ? "Evaluations"
                                : "Total Evaluations"}
                            </span>
                            <span className="headline-5 dark-100">
                              {totalAttempted}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <AttemptsStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        {routeDetails?.text?.toUpperCase() === "ARCHIVED" ? (
                          <div className="assessments-stats-card">
                            <div className="stats-card-text">
                              <span className="body-2 dark-50">
                                {isOnTabScreen
                                  ? "Archived"
                                  : "Archived Assessments"}
                              </span>
                              <span className="headline-5 dark-100 ">
                                {archiveAssessments}
                              </span>
                            </div>
                            <div className="AssessmentsStatsIcon-container">
                              <ArchiveStatsIcon className="AssessmentsStatsIcon" />
                            </div>
                          </div>
                        ) : routeDetails?.text?.toUpperCase() === "DRAFT" ? (
                          <div className="assessments-stats-card">
                            <div className="stats-card-text">
                              <span className="body-2 dark-50">
                                {isOnTabScreen ? "Draft" : "Draft Assessments"}
                              </span>
                              <span className="headline-5 dark-100">
                                {draftAssessments}
                              </span>
                            </div>
                            <div className="AssessmentsStatsIcon-container">
                              <DraftStatsIcon className="AssessmentsStatsIcon" />
                            </div>
                          </div>
                        ) : (
                          <div className="assessments-stats-card">
                            <div className="stats-card-text">
                              <span className="body-2 dark-50">
                                {isOnTabScreen
                                  ? "Active"
                                  : "Active Assessments"}
                              </span>
                              <span className="headline-5 dark-100">
                                {activeAssessments}
                              </span>
                            </div>
                            <div className="AssessmentsStatsIcon-container">
                              <ActiveStatsIcon className="AssessmentsStatsIcon" />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="w-100 hide-scrollbar"
                      style={{
                        height: "calc(100vh - 265px)",
                        borderRadius: "24px",
                        background: "white",
                        overflowY: "auto",
                        position: "relative",
                      }}
                    >
                      <div className="table-search-container">
                        <div className="table-search-input">
                          <Search height={"24px"} width={"24px"} />
                          <Input
                            inputStyle={{
                              background: "transparent",
                              border: "none",
                            }}
                            className={"w-100"}
                            placeholder={"Search"}
                            value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setCurrentPage(1);
                            }}
                          />
                          <SearchCrossIcon
                            height={"24px"}
                            width={"24px"}
                            cursor={"pointer"}
                            onClick={() => {
                              setSearchQuery("");
                              setCurrentPage(1);
                            }}
                          />
                        </div>
                      </div>
                      {!draftPopupShown &&
                        draftAssessments > 0 &&
                        activeAssessments === 0 &&
                        archiveAssessments === 0 && (
                          <CustomModal
                            open={
                              !draftPopupShown &&
                              draftAssessments > 0 &&
                              activeAssessments === 0 &&
                              archiveAssessments === 0
                            }
                            varrient="alert-warning-modal"
                            title={`Saved as Draft`}
                            description={`All new assessments are saved as draft by default.`}
                            handleCloseModal={() => {
                              handleCloseDraftPopupShown();
                            }}
                            confirmBtnTitle={"Go to Drafts"}
                            btnWidth={"max-content"}
                            onConfirm={() => {
                              handleCloseDraftPopupShown();
                              history.push(`${PathName.ASSESSMENTS}/draft`);
                            }}
                          />
                        )}
                      {(assessSpec?.loading &&
                        assessSpec?.data?.results === null) ||
                      loading ? (
                        <div className="processing-indicator-wrapper medium-indicator w-100 h-100 d-flex align-items-center justify-content-center">
                          <div
                            className="processing-indicator primary"
                            style={{ width: "40px", height: "40px" }}
                          />
                        </div>
                      ) : assessSpec?.data?.results.length === 0 ? (
                        defaultAssessmentCard()
                      ) : (
                        <Table
                          headers={
                            auth.data.role.name === "Member"
                              ? assessmentTableHeaderViewOnly
                              : assessmentTableHeader
                          }
                          data={testData}
                          onSelectRow={handleRowSelect}
                          disableSearchInput={true}
                          setHighlightActiveRow={setHighlightActiveRow}
                          // searchColumns={searchColumns}
                          // customSorting={customSorting}
                          // customSearch={customSearch}
                          backendFilter={true}
                          setSelectedsortOption={
                            handleAssessmentSortOptionChange
                          }
                          selectedsortOption={selectedsortOption}
                          setCurrentPage={setCurrentPage}
                          currentPage={currentPage}
                          totalItems={totalItems}
                          itemsPerPage={itemsPerPage}
                          totalPages={totalPages}
                          nextSlide={nextSlide}
                          prevSlide={prevSlide}
                          nullTableLoading={true}
                          // nullTableTitle={"No Assessments to show"}
                          // nullTableDescription={`Try adjusting your search query or filters`}
                          onRowsPerPageChange={handleRowsPerPageChange}
                        />
                      )}
                    </div>
                  </>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

// import React, { useState, useEffect } from "react";
// import {
//   Route,
//   useHistory,
//   useLocation,
// } from "react-router-dom/cjs/react-router-dom";
// import {
//   createAssessSpec,
//   listAssessSpec,
//   listAssessSpecWithQueryParam,
//   getAssessSpecStatsData,
// } from "../../../redux/thunks/AssessSpec";
// import { useDispatch, useSelector } from "react-redux";
// import Assessments from "./assesment-listing/Assessments";
// import Button from "../../../components/sub-component/Button";
// import { AssessmentsRoutes, PathName } from "../../../utils/routes";

// export default function AdminAssessments(props) {
//   /**
//    * @type {TAssessSpecState}
//    */

//   const history = useHistory();
//   const dispatch = useDispatch();
//   const assessSpec = useSelector((state) => state.assessSpecReducer);
//   const { routeDetails } = props;

//   const [actionAssessmentModal, setActionAssessmentModal] = useState({
//     isOpen: false,
//     assessSpec: null,
//     action: "",
//   });
//   const [selectedsortOption, setSelectedsortOption] = useState({
//     column: "created_at",
//     order: "DESC",
//     clickCount: 0,
//   });
//   const [searchQuery, setSearchQuery] = useState("");

//   const location = useLocation();

//   const searchParams = new URLSearchParams(location.search);
//   const pageNo = searchParams.get("page");

// 	const [currentPage, setCurrentPage] = useState(parseInt(`${pageNo}`) || 1);
// 	const [totalItems, setTotalItems] = useState(0);
// 	const getInitialRowsPerPage = () => {
// 		const saved = localStorage.getItem('assessmentsRowsPerPage');
// 		return saved ? parseInt(saved, 10) : 10;
// 	};
// 	const [itemsPerPage, setItemsPerPage] = useState(getInitialRowsPerPage());
// 	const totalPages = Math.ceil(totalItems / itemsPerPage);

//   const nextSlide = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const prevSlide = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleCreateAssessSpec = async () => {
//     const { payload } = await dispatch(createAssessSpec({ title: "New Test" }));
//     history.push(`${PathName.ASSESSMENTS}/create/${payload.id}`);
//   };

//   useEffect(() => {
//     dispatch(
//       getAssessSpecStatsData({
//         status:
//           routeDetails.pathname === "/active"
//             ? "ACTIVE"
//             : routeDetails.pathname === "/draft"
//             ? "DRAFT"
//             : "ARCHIVED",
//       })
//     );
//   }, [routeDetails.pathname, actionAssessmentModal]);

//   useEffect(() => {
//     if (assessSpec?.data === null) return;
//     setTotalItems(assessSpec?.data?.count);
//   }, [assessSpec?.data]);
// 	const handleRowsPerPageChange = (newLimit) => {
// 		setItemsPerPage(newLimit);
// 		setCurrentPage(1);
// 		localStorage.setItem('assessmentsRowsPerPage', newLimit);
// 	};

//   useEffect(() => {
//     if (assessSpec?.data?.results?.length === 0) {
//       setQueryParam("page", 1);
//       setCurrentPage(1);
//     } else {
//       setQueryParam("page", currentPage);
//     }
//   }, [assessSpec?.data?.results?.length, currentPage, history]);
//   const setQueryParam = (key, value) => {
//     searchParams.set(key, value);
//     history.push({
//       pathname: location.pathname,
//       search: searchParams.toString(),
//     });
//   };

// useEffect(() => {
// 		// dispatch(listAssessSpec({ query: '?limit=100' }));
// 		dispatch(listAssessSpecWithQueryParam({
// 			data: {
// 				page: currentPage,
// 				limit: itemsPerPage,
// 				sort_by: selectedsortOption.column,
// 				sort_direction: selectedsortOption.order === 'none' ? 'ASC' : selectedsortOption.order,
// 				status: routeDetails.pathname === '/active' ? 'ACTIVE' : routeDetails.pathname === '/draft' ? 'DRAFT' : 'ARCHIVED',
// 				search: searchQuery,
// 			}
// 		}));
// 	}, [searchQuery, selectedsortOption, currentPage, actionAssessmentModal, itemsPerPage]);

// 	return (
// 		<div className="assessment-view-container hide-scrollbar" style={{overflowY:'auto'}}>
// 			{
// 				assessSpec?.loading && assessSpec?.data?.results === null ? (
// 					<div style={{ position: 'fixed', top: '0', bottom: '0', left: '0', right: '0', height: '25px', width: '25px', margin: 'auto' }}>
// 						<div className="processing-indicator" style={{ width: '100%', height: '100%' }} />
// 					</div>
// 				) : (
// 					<Assessments
// 						data={assessSpec?.data?.results ? assessSpec?.data?.results?.filter((spec, _) => { return (spec?.status === routeDetails?.text?.toUpperCase()); }) : []}
// 						totalAssessments={assessSpec?.statsData?.stats ? assessSpec?.statsData?.stats?.total_spec_count : 0}
// 						activeAssessments={assessSpec?.statsData?.stats ? assessSpec?.statsData?.stats?.active_spec_count : 0}
// 						draftAssessments={assessSpec?.statsData?.stats ? assessSpec?.statsData?.stats?.draft_spec_count : 0}
// 						archiveAssessments={assessSpec?.statsData?.stats ? assessSpec?.statsData?.stats?.archived_spec_count : 0}
// 						totalInvited={assessSpec?.statsData?.stats ? assessSpec?.statsData?.stats?.spec_status_stats?.assess_invited : 0}
// 						totalAttempted={assessSpec?.statsData?.stats ? assessSpec?.statsData?.stats?.spec_status_stats?.assess_completed : 0}
// 						// activeAssessments={assessSpec?.data?.results ? assessSpec?.data?.results?.filter((spec, _) => { return (spec?.status === 'ACTIVE'); }).length : 0}
// 						// draftAssessments={assessSpec?.data?.results ? assessSpec?.data?.results?.filter((spec, _) => { return (spec?.status === 'DRAFT'); }).length : 0}
// 						// archiveAssessments={assessSpec?.data?.results ? assessSpec?.data?.results?.filter((spec, _) => { return (spec?.status === 'ARCHIVED'); }).length : 0}
// 						// totalInvited={assessSpec?.data?.results?.reduce((sum, obj) => {
// 						// 	// Check if obj.invited is a valid number before adding it to the sum
// 						// 	if (typeof obj.invited === 'number' && !isNaN(obj.invited)) {
// 						// 		return sum + obj.invited;
// 						// 	}
// 						// 	return sum; // If not a valid number, skip and keep the current sum
// 						// }, 0)}
// 						// totalAttempted={assessSpec?.data?.results?.reduce((sum, obj) => {
// 						// 	// Check if obj.invited is a valid number before adding it to the sum
// 						// 	if (typeof obj.completed === 'number' && !isNaN(obj.completed)) {
// 						// 		return sum + obj.completed;
// 						// 	}
// 						// 	return sum; // If not a valid number, skip and keep the current sum
// 						// }, 0)}
// 						routeText={routeDetails.text}
// 						variant={routeDetails.pathname === '/active' ? 'active' : routeDetails.pathname === '/draft' ? 'draft' : 'archived'}
// 						assessSpecProcessing={assessSpec?.processing}
// 						assessSpecLoading={assessSpec?.loading}
// 						handleCreateAssessSpec={handleCreateAssessSpec}
// 						setActionAssessmentModal={setActionAssessmentModal}
// 						actionAssessmentModal={actionAssessmentModal}
// 						setSelectedsortOption={setSelectedsortOption}
// 						selectedsortOption={selectedsortOption}
// 						setSearchQuery={setSearchQuery}
// 						searchQuery={searchQuery}
// 						setCurrentPage={setCurrentPage}
// 						currentPage={currentPage}
// 						totalItems={totalItems}
// 						itemsPerPage={itemsPerPage}
// 						totalPages={totalPages}
// 						nextSlide={nextSlide}
// 						prevSlide={prevSlide}
// 						onRowsPerPageChange={handleRowsPerPageChange}
// 					/>
// 				)
// 			}
// 		</div>
// 	);
// }
